import { render, staticRenderFns } from "./salesTableF.vue?vue&type=template&id=5c13724c&scoped=true"
import script from "./salesTableF.vue?vue&type=script&lang=js"
export * from "./salesTableF.vue?vue&type=script&lang=js"
import style0 from "./salesTableF.vue?vue&type=style&index=0&id=5c13724c&prod&scoped=true&lang=css"
import style1 from "./salesTableF.vue?vue&type=style&index=1&id=5c13724c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13724c",
  null
  
)

export default component.exports